import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-fancy-toast',
  templateUrl: './fancy-toast.component.html',
  styleUrls: ['./fancy-toast.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class FancyToastComponent implements OnInit, OnDestroy {

  @Input() message: string = '';
  @Input() bgGradient: string = '';
  @Input() textColor: string = '#fff';
  @Input() icon: string = '';
  @Input() action: string = '';

  @Input() showOk: boolean = false;
  @Input() showClose: boolean = true;

  @Input() position: 'top-right' | 'top' = 'top-right';
  @Input() duration: number = 6000;

  @Output() okClick = new EventEmitter<void>();
  @Output() closeClick = new EventEmitter<void>();

  progressWidth: number = 100;
  iconAnimated: boolean = false;
  private timer: any;
  private interval: any;
  private remaining = 0;
  private startTime = 0;

  closing: boolean = false;

  ngOnInit() {
    if(window.innerWidth < 768) this.position = 'top';
setTimeout(() => {
    this.iconAnimated = true;
  }, 300); // match slide-in animation duration

  this.startTimer();
  this.startProgress();
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
    clearInterval(this.interval);
  }

  startTimer() {
    this.startTime = Date.now();
    this.remaining = this.duration;
    this.timer = setTimeout(() => this.closeToast(), this.remaining);
  }

  startProgress() {
    const stepTime = 50;
    this.progressWidth = 100;
    this.interval = setInterval(() => {
      this.progressWidth -= (stepTime / this.duration) * 100;
      if(this.progressWidth <= 0) {
        this.progressWidth = 0;
        clearInterval(this.interval);
      }
    }, stepTime);
  }

  pauseTimer() {
    clearTimeout(this.timer);
    clearInterval(this.interval);
    const elapsed = Date.now() - this.startTime;
    this.remaining = Math.max(this.remaining - elapsed, 0);
  }

  resumeTimer() {
    this.startTime = Date.now();
    this.timer = setTimeout(() => this.closeToast(), this.remaining);

    const stepTime = 50;
    this.interval = setInterval(() => {
      this.progressWidth -= (stepTime / this.remaining) * 100;
      if(this.progressWidth <= 0) {
        this.progressWidth = 0;
        clearInterval(this.interval);
      }
    }, stepTime);
  }

  closeToast(){
    if(this.closing) return; // already closing
    this.closing = true;

    // Wait animation duration before emitting
    setTimeout(() => this.closeClick.emit(), 300); // match CSS animation
  }
}